<div>
    <forge-icon-button [attr.dense]="forCellEdit" (click)="executeAction($event, true)" class="generic-button"
        [disabled]="!allowAdd() || viewOnly" attr.telemetry="Submission-Add{{Tooltip}}"
        attr.aria-label="add {{Tooltip}}">
        <forge-tooltip>Add {{Tooltip}}</forge-tooltip>
        <forge-icon name="add"></forge-icon>
    </forge-icon-button>
    <forge-icon-button [attr.dense]="forCellEdit" (click)="executeAction($event)" [disabled]="!CanEdit"
        class="generic-button" attr.telemetry="Submission-Edit{{Tooltip}}" attr.aria-label="edit {{Tooltip}}">
        <forge-tooltip>Edit {{Tooltip}}</forge-tooltip>
        <forge-icon name="edit"></forge-icon>
    </forge-icon-button>
</div>